import React, { ReactElement, useMemo } from 'react';
import { Auth0Provider } from './Auth0Provider';
import { IAuthAppState } from './IAuthAppState';
import { appHistory } from 'components/History';
import { getAuthConfig } from './AuthConfig';
import { IRoute, allRoutes } from 'components/navigation/routes';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { getAuthenticationState } from './Authentication';
import { Auth0ClientOptions, GetTokenSilentlyOptions, 
	GetUserOptions, RedirectLoginResult } from "@auth0/auth0-spa-js"

interface IProps
{
	children?: ReactElement | ReactElement[]
}

/** Component that sets up authorization. Keeps the index.tsx file clean and functionality separated. */
export function AuthWrapper(props: IProps)
{
	const { clientOptions, getUserOptions, getTokenSilentlyOptions } = useMemo(() =>
	{
		const config = getAuthConfig();
		const clientOptions: Auth0ClientOptions = {
			domain: config.domain,
			client_id: config.client_id,
			scope: config.scope,
			audience: config.audience
		};

		const getUserOptions: GetUserOptions = {
			scope: config.scope,
			audience: config.audience
		};

		const getTokenSilentlyOptions: GetTokenSilentlyOptions = {
			scope: config.scope,
			audience: config.audience
		}

		return { clientOptions, getUserOptions, getTokenSilentlyOptions }
	}, []);

	return (
		<Auth0Provider
			clientOptions={clientOptions}
			onRedirectCallback={onRedirectCallback}
			getUserOptions={getUserOptions}
			getTokenSilentlyOptions={getTokenSilentlyOptions}
			onAuthencticationFinished={onAuthenticationFinished}
		>
			{props.children}
		</Auth0Provider>
	);
};

function onAuthenticationFinished()
{
	const authState = getAuthenticationState();
	if (authState.isAuthenticated && appHistory.location.pathname === '/') {
		const route: IRoute = allRoutes.find(r => r.routeId === RouteId.home) as IRoute;
		// console.log('route', route);
		appHistory.replace(route.path);
	}
}

/** Gets called when the user returns to the application after a succesful login. */
function onRedirectCallback(result?: RedirectLoginResult)
{
	if (result) {
		// console.log('result', result);
		if (result.appState) {
			const appState = result.appState as IAuthAppState;

			// console.log('appState', result.appState);
			appHistory.push({
				pathname: appState.path,
				search: appState.search,
				hash: appState.hash
			});
		}
	}
}